import { ErrorLevel } from '@griply/utils';
import { getGlobalAllowedSearchParameters } from 'shared/lib/react-router-dom';
import { getErrorReporter } from 'shared/services/error-tracking';
import { createNonce } from 'shared/services/local-storage';

import { getAppleId } from './get-apple-id';

export const getAppleToken = async () => {
  const appleId = await getAppleId();

  if (!appleId) {
    getErrorReporter().captureMessage('no apple id found', ErrorLevel.Error, {
      tags: { source: 'apple-token-init' },
    });
  }

  const { hashed } = await createNonce();

  const authOptions = {
    nonce: hashed,
    scope: 'email name',
    clientId: import.meta.env.VITE_APPLE_CLIENT_ID,
    redirectURI: import.meta.env.VITE_APPLE_REDIRECT_URI,
    state: JSON.stringify(
      Object.fromEntries(getGlobalAllowedSearchParameters()),
    ),
  };

  appleId.auth.init(authOptions);

  await appleId.auth.signIn();
};
